export const DELETE_CREDIT_CARD_MODAL_NAME = 'DELETE_CREDIT_CARD_MODAL_NAME';
